/*
 * Copyright (c) 2023. All rights are reserved to Newport Collection
 */

import theme from 'components/theme';

const coreStyle = {
	search__wrapper: {
        padding: '0',
		position: 'relative',
		display: 'flex',
        flexDirection: 'column',
		minHeight: 38,
		maxWidth: '1600px',
		maxHeight: 'calc(80vh - var(--inner-header-height))',
        overflowY: 'auto',
        zIndex: 1200,
        width: '100%',
        '&.focus': {
            [theme.breakpoints.down('sm')]: {
                'body:has(&)': {
                  overflow: 'hidden',
                },
            },
        },
	},
	search__inner: {
		position: 'relative',
		zIndex: 100,
		width: '100%',
        padding: '0',
	},
	search__input: {
		width: '100%',
		height: 38,
		padding: '1.25em 1em',
		margin: 0,
		fontSize: 16,
		fontFamily: theme.typography.fontFamily,
		color: theme.palette.header.search.color,
		borderRadius: '4px',
		border: `1px solid ${theme.palette.primary.backgroundContrast}`,
		appearance: 'none',
		'&:focus-visible': {
			outline: 'none'
		},
		'&.glued.focus': {
			boxShadow: 'none'
		},
		'&.focus': {
			outline: 'none'
		},
		'&::placeholder': {
			color: theme.palette.header.search.color
		},
		'.xmas &': {
			background: theme.palette.primary.main,
		},
	},
	icon__button: {
		position: 'absolute',
		minWidth: 'auto',
		minHeight: 'auto',
		top: 0,
        bottom: 0,
		right: 0,
        padding: '0 15px',
		backgroundColor: 'transparent',
        '.xmas &': {
            backgroundColor: theme.palette.primary.background,
            color: '#000'
        }
	},
	icon__button_control: {
		borderTopLeftRadius: '0',
		borderBottomLeftRadius: '0',
		'&.glued': {
			borderRadius: 0
		},
		'.xmas &': {
			color: '#fff !important',
		}
	},
	control__icon: {
		width: 18,
		height: 18,
		'&.focus *': {
			stroke: theme.palette.primary.light,
			'.xmas &': {
				stroke: theme.palette.primary.main,
			}
		},
	},
	autocomplete: {
        display: 'none',
		zIndex: 100,
		width: '100%',
		overflow: 'auto',
		overflowX: 'hidden',
		maxWidth: '100%',
        margin: '0',
        top: '100%',
        left: 0,
        right: 0,
        background:'#fff',
        position: 'fixed',
        padding: '1em max(22px, calc((100vw - 1600px) / 2)) 2em',
        maxHeight: '65vh',
		'&.glued': {
			boxShadow: 'none',
			borderRadius: 0
		},
		'&.focus': {
			display: 'block'
		},
        [theme.breakpoints.up('md')]: {
            top: 'var(--inner-header-height)',
        },
	},
    resultsContainer: {
        '& .MuiGrid-item': {
            flexDirection: 'row',
            '& div': {

            }
        }
    },
	suggestion: {
		width: 'auto',
		padding: '4px 0',
        marginRight: 15,
		letterSpacing: '.15rem',
		opacity: 0,
		'&.focus': {
			transform: 'translateX(0)',
			opacity: 1,
			letterSpacing: '0'
		},
		'& a': {
			display: 'flex',
			alignItems: 'center',
			fontWeight: 400,
			color: 'inherit',
			textDecoration: 'none',
			whiteSpace: 'nowrap',
            '&:hover': {
                textDecoration: 'underline',
            },
		},
		'& .searchIcon': {
			marginRight: 8,
			flexShrink: 0,
			color: '#000',
		}
	},
	suggestions__wrapper: {
		paddingBottom: 20,
		marginBottom: 15,
		borderBottom: `1px solid ${theme.palette.primary.backgroundContrast}`,
		'& ul': {
			display: 'flex',
			flexWrap: 'wrap',
			gap: 8
		},
		[theme.breakpoints.up('sm')]: {
			marginBottom: 0,
			borderBottom: 'none'
		},
		[theme.breakpoints.down('sm')]: {
			'& li:nth-of-type(n + 6)': {
				display: 'none'
			}
		}
	},
	productSuggestion__link: {
		boxShadow: 'none'
	},
	products__wrapper: {
        marginBottom: '0.5em',
        '&:last-of-type': {
            borderBottom: 'none',
            paddingBottom: 0,
        }
	},
	product: {
		display: 'flex',
		alignItems: 'center',
		padding: 0,
		textDecoration: 'none',
		opacity: 0,
		backgroundColor: theme.palette.primary.background,
		'&.focus': {
			opacity: 1,
		},
		'&:hover': {
			backgroundColor: theme.palette.primary.backgroundContrast
		},
		[theme.breakpoints.down('sm')]: {
			'&.focus': {
				transitionDelay: '.5s'
			}
		}
	},
	product__image: {
		position: 'relative',
		width: 90,
		marginRight: 10,
		overflow: 'hidden',
		'& > div': {
			display: 'block !important'
		},
        '&.inspiration': {
            width: '90px',
            display: 'block',
            aspectRatio: 1,
            '& img': {
                objectFit: 'cover',
                objectPosition: 'center 30%'
            },
        },
		'&:after': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			pointerEvents: 'none',
			mixBlendMode: 'multiply',
			boxShadow: 'inset 0 0 90px 8px rgb(240, 240, 240, 0.75)'
		}
	},
	product__info: {
		display: 'flex',
		alignSelf: 'center',
        justifyContent: 'space-between',
        flexDirection: 'column',
        width: '100%',
        padding: '5px',
	},
	product__name: {
		fontSize: 14,
		fontWeight: 300,
		color: theme.palette.primary.text
	},
	product__prices: {
		display: 'flex'
	},
	product__price: {
		fontSize: 13,
		color: '#333',
		'&.special': {
			color: theme.palette.primary.special
		},
		'&.old': {
			marginLeft: 10,
			textDecoration: 'line-through',
			color: theme.palette.primary.disabled
		}
	},
    product__type: {
        fontSize: 14,
        fontWeight: 300,
        fontStyle: 'italic',
        color: theme.palette.primary.text,
        textTransform: 'capitalize',
        '&.desktop': {
            display: 'none'
        },
        [theme.breakpoints.up('sm')]: {
            '&.desktop': {
                display: 'block',
                fontStyle: 'unset',
                fontWeight: 500,
                marginBottom: '5px',
            },
            '&.mobile': {
                display: 'none'
            }
        }
    },
    showMoreItem: {
        position: 'sticky',
        bottom: '-2em',
        padding: '1em 0',
        background: '#fff',
    },
	product__showMore: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		...theme.button.purchase,
		margin: 0,
		padding: '10px 15px',
		backgroundColor: theme.palette.primary.purchase.background,
		fontSize: 12,
		textDecoration: 'none',
		'&:hover': {
			backgroundColor: theme.palette.primary.purchase.hover,
		},
		'.xmas &': {
			backgroundColor: theme?.palette?.primary?.main
		},
        '.blackfriday &': {
			backgroundColor: theme.palette.header.background,
		}
	},
	noResultsText: {
		fontSize: 14,
		color: theme.palette.primary.foreground
	},
	relatedSearches: {
		margin: '0 0 10px',
		fontWeight: 500,
		fontSize: 14
	},
};

module.exports = coreStyle;
